import { create } from "zustand";
import { authorize, loadSession, logout } from "./actions";

type User = {
    uname:string
    app:string
    com:string
    expire:number
    roles:string[]
    dis:string
    session:string
}

type AuthProps = {
    loading: boolean
    isLogin: boolean
    user:User | null
    authorize: (code:string,company:string) => Promise<string>
    isInit: boolean
    init: () => Promise<string> // return true if login successfully
    logout: () => void
    isValid: () => boolean,
}

export const useAuth = create<AuthProps>( (set, getState) => ({
    loading: false,
    isLogin: false,
    isInit: false,
    user: null,
    async init() {
        const isinit = getState().isInit
        if (isinit) return ""
        try {
            const res = await loadSession()
            //console.log("init auth response:", res)
            if (res.Code === '200' && res.Msg) {
                const decoded = res.Msg
                //console.log("decoded user data:", decoded)
                set( state => ({isLogin: true,loading:false, user:decoded, isInit:true}))
            } else {
                console.log("No valid session found")
                set( state => ({loading:false, isInit:true}))
            }
        } catch (error) {
            console.error("Error loading session:", error)
            set( state => ({loading:false, isInit:true}))
        }
        return ""
    },
    async authorize(code:string,company:string) {
        //console.log("authorizing with code and company:", code, company)
        if (getState().loading) return ""
        set( state => ({loading:true, isInit:true}))
        try {
            const data = await authorize(code,company)
            //console.log("authorize response:", data)
            if (data.Code === '200' && data.Msg) {
                const user = data.Msg
                console.log("setting user data:", user)
                set( state => ({loading:false, isLogin:true, user:user}))
            } else {
                console.error("Invalid authorize response:", data)
                set( state => ({loading:false, isLogin:false}))
            }
            return data.Code
        } catch (error) {
            console.error("Error during authorization:", error)
            set( state => ({loading:false, isLogin:false}))
            throw error
        }
    },
    async logout() {
        await logout()
        set(state => ({isLogin:false,user:null}))
    },
    isValid() {
        const user = getState().user
        if (user === null) return false
        if ( Date.now() > user.expire ) return false
        return true
    },
}))

